<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view></router-view>
    <!-- <wizard /> -->
  </div>
</template>

<script>
import Wizard from './components/Wizard'

export default {
  name: 'app',
  components: { Wizard }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
html {
  /*background: linear-gradient(141deg, #0fb8ad 0%, #1fc8db 51%, #2cb5e8 75%);*/
  background-color: #0fb8ad;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?bdc26cf4